<h2 mat-dialog-title class="modal-title">{{ title }}</h2>

<mat-dialog-content class="modal-content">
  <p class="modal-subtitle">
    Update the product details below. Fields marked with <span class="required-star">*</span> are required.
  </p>

  <form [formGroup]="form" class="edit-form">
    <div class="form-grid">

      <!-- Brand -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Brand <span class="required-star">*</span></mat-label>
        <input matInput formControlName="brand" placeholder="e.g. Nike" autocomplete="off">
        <mat-error *ngIf="form.get('brand')?.hasError('required')">Brand is required.</mat-error>
      </mat-form-field>

      <!-- Item -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Item <span class="required-star">*</span></mat-label>
        <input matInput formControlName="item" placeholder="e.g. Sneakers" autocomplete="off">
        <mat-error *ngIf="form.get('item')?.hasError('required')">Item is required.</mat-error>
      </mat-form-field>

      <!-- Material -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Material</mat-label>
        <input matInput formControlName="material" placeholder="e.g. Leather" autocomplete="off">
      </mat-form-field>

      <!-- Color -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Color</mat-label>
        <input matInput formControlName="color" placeholder="e.g. Black" autocomplete="off">
      </mat-form-field>

      <!-- Price -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Price (USD)</mat-label>
        <input matInput formControlName="price" type="number" min="0" placeholder="e.g. 120" autocomplete="off">
        <mat-error *ngIf="form.get('price')?.hasError('min')">Price must be a positive number.</mat-error>
      </mat-form-field>

      <!-- Age -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Product Age</mat-label>
        <mat-select formControlName="age">
          <mat-option *ngFor="let opt of ageOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Condition — full width -->
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Product Condition</mat-label>
        <mat-select formControlName="condition">
          <mat-option *ngFor="let opt of conditionOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button mat-stroked-button type="button" (click)="cancel()" class="cancel-btn">
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="submit()"
    [disabled]="form.invalid"
    class="submit-btn"
  >
    Save Changes
  </button>
</mat-dialog-actions>
